export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_et.0c90feb1671ba0ea.json"